import React, { useEffect, useState } from "react";
import { Container, Button, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import Header from "../components/LoanUnderwrite/Header";
import Steps from "../components/LoanUnderwrite/Steps";
import UnderwriteLoan from "./UnderwriteLoan.jsx";
import UserService from "../services/UserService";
import { MDBDataTable } from "mdbreact";

const serverConfig = require("../config/server.js");

const LoanUnderwriteLanding = () => {
  const [token, setToken] = useState(null);
  const [company, setCompany] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [currentStep, setCurrentStep] = useState("Loans");

  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const [inputs, setInputs] = useState({
    applicationNumber: "",
    nameOfBusiness: "",
    loanAmount: "",
    city: "",
    timeInBusiness: "",
    timeInBusinessPoints: "",
    numberOfEmployees: "",
    numberOfEmployeesPoints: "",
    highCredit: "",
    highCreditPoints: "",
    paydex: "",
    paydexPoints: "",
    tradeLines: "",
    tradeLinesPoints: "",
    suitsLiensJudgements: "",
    suitsLiensJudgementsPoints: "",
    historyClearSwitch: false,
    historyClearPoints: "",
    uccFilingsSwitch: false,
    uccFilingsPoints: "",
    highRiskIndustrySwitch: false,
    highRiskIndustryPoints: "",
    comparableLeaseSwitch: false,
    comparableLeasePoints: "",
    majorityEquitySingleOwnershipSwitch: false,
    majorityEquitySingleOwnershipPoints: "",
    preferredCollateralSwitch: false,
    preferredCollateralPoints: "",
    softCollateralSwitch: false,
    softCollateralPoints: "",
    intangiblesSwitch: false,
    intangibles: "",
    intangiblesPoints: "",
    anyMajorDerogSwitch: false,
    venderMustBeCleared: false,
    // Loan Application Details
    assetType: "",
    bankruptcy: "",
    commercialCreditScore: "",
    ficoScore: "",
    optimismIndex: 0,
    gdpGrowthRate: 0,
    cpiIndex: 0,
    fedFundsRate: 0,
    industrialProductionIndex: 0,
    unemploymentRate: 0,
    cpiMoM: 0,
    cpiRoll3M: 0,
    gdpRoll3Q: 0,
    unemploymentRoll3M: 0,
    optimismRoll6M: 0,
    industrialProdChange6M: 0,
    covidFlag: 0,
    optimismIndexNormalized: 0,
    unemploymentRateNormalized: 0,
    gdpGrowthRateNormalized: 0,

    // Personal Guarantor (PG) Details
    pgTimeInBusiness: "",
    pgFicoScore: "",
    pgStrongPaymentHistorySwitch: false,
    pgAcceptableCreditHistorySwitch: false,
    pgStrongComparibleCreditSwitch: false,
    pgAcceptableComparibleCreditSwitch: false,
    pgPreferredCollateralSwitch: false,
    pgSoftCollateralSwitch: false,
    pgIntangiblesSwitch: false,
    pgIntangibles: "",
  });

  // const [nextDisabled, setNextDisabled] = useState(true);

  const [selectedType, setSelectedType] = useState("");

  const handleTypeChange = (event) => {
    const value = event.target.value;
    setSelectedType(value);
  };

  let el = document.querySelectorAll("input[required]");

  const handleLogout = () => {
    sessionStorage.clear();
    UserService.doLogout();
  };

  const getToken = () => {
    console.log(sessionStorage.getItem("token"));
    let jwt = UserService.getToken();
    axios
      .post(serverConfig.api_base_url + "user_get_token", { jwt: jwt })
      .then((response) => {
        console.log("user_get_token response", response);
        if (response.data.status === 200) {
          sessionStorage.setItem("token", response.data.token);
          setToken(response.data.token);
        } else if (response.data.status >= 400 && response.data.status <= 499) {
          alert(response.data.message);
        } else if (response.data.jwt_validation === "fail") {
          handleLogout();
        }
      })
      .catch((err) => console.log("error is", err));
  };

  useEffect(() => {
    console.log(sessionStorage.getItem("token"));
    if (sessionStorage.getItem("token") === null) {
      getToken();
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, []);

  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: type === "checkbox" || type === "switch" ? checked : value,
    }));
    setInputs((stateInputs) => {
      console.log(Object.keys(stateInputs).length, Object.keys(stateInputs));
      console.log(el.length - 1);
      if (Object.keys(stateInputs).length === el.length - 1) {
      } else {
      }
      return stateInputs;
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
  };

  // LoanTable related
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState(null);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${serverConfig.api_base_url}underwriting-engine/loans?search=${searchTerm}`
      );
      const json = await response.json();

      if (json.status === "success" && Array.isArray(json.data)) {
        console.log("Loan data fetched successfully:", json.data);
        const rows = json.data.map((row) => ({
          applicationNumber: row["Application Number"],
          submitDate: row["Submit Date"].split("T")[0],
          loanAmount: `$${parseFloat(row["Submit Cost"]).toFixed(2)}`,
          assetType: row["Asset Type"],
          officeName: row["Office Name"],
          action: (
            <Button
              variant="transparent"
              className=""
              type="submit"
              onClick={() => {
                handleUnderwrite(row["Application Number"]);
              }}
            >
              Process Loan
            </Button>
          ),
        }));

        setTableData({
          columns: [
            {
              label: "Application Number",
              field: "applicationNumber",
              sort: "asc",
            },
            {
              label: "Submit Date",
              field: "submitDate",
              sort: "asc",
            },
            {
              label: "Loan Amount",
              field: "loanAmount",
              sort: "asc",
            },
            {
              label: "Asset Type",
              field: "assetType",
              sort: "asc",
            },
            {
              label: "Office Name",
              field: "officeName",
              sort: "asc",
            },
            {
              label: "Action",
              field: "action",
              sort: "disabled",
            },
          ],
          rows,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleUnderwrite = async (applicationNumber) => {
    setIsLoading(true);
    const res = await fetch(
      `${serverConfig.api_base_url}underwriting-engine/loans/${applicationNumber}`
    );
    const json = await res.json();
    setIsLoading(false);
    console.log(json);

    if (json.status === "success") {
      const suits = json.data["SUITS"];
      const liens = json.data["LIENS"];
      const judgements = json.data["JUDGEMENTS"];

      const values = [suits, liens, judgements];

      let countSLJ;
      const naCount = values.filter((v) => v === "<NA>").length;

      if (naCount === 0) {
        countSLJ = -3; // none are <NA>
      } else if (naCount === 3) {
        countSLJ = 1; // all are <NA>
      } else {
        countSLJ = 0; // 1 or 2 are <NA>
      }
      setInputs({
        ...json.data,
        applicationNumber: json.data["Application Number"],
        nameOfBusiness: json.data["Name of Business"],
        assetType: json.data["Asset Type"],
        bankruptcy: json.data["BANKRUPTCY"],
        commercialCreditScore: json.data["COM_CRE_SCORE"],
        loanAmount: json.data["Submit Cost"],
        ficoScore: json.data["FICO_AVG"],
        highCredit: json.data["AVG_HI_CREDIT"],
        city: json.data["Customer Billing City"],
        timeInBusiness: json.data["LW_YRS_IN_BUS"],
        numberOfEmployees: json.data["EMP_TOT"],
        highCredit: json.data["HIGH_CREDIT"],
        paydex: json.data["PAYDEX_FIRM"],
        tradeLines: json.data["NUM_TRADE_EXP"],
        judgements: json.data["JUDGEMENTS"],
        liens: json.data["LIENS"],
        suits: json.data["SUITS"],
        suitsLiensJudgements: countSLJ,
        optimismIndex: Number(json.data["Optimism_Index"]) || 0,
        gdpGrowthRate: Number(json.data["GDP_Growth_Rate"]) || 0,
        cpiIndex: Number(json.data["cpi_index"]) || 0,
        fedFundsRate: Number(json.data["fed_funds_rate"]) || 0,
        industrialProductionIndex:
          Number(json.data["industrial_production_index"]) || 0,
        unemploymentRate: Number(json.data["unemployment_rate"]) || 0,
        cpiMoM: Number(json.data["CPI_MoM"]) || 0,
        cpiRoll3M: Number(json.data["CPI_Roll3M"]) || 0,
        gdpRoll3Q: Number(json.data["GDP_Roll3Q"]) || 0,
        unemploymentRoll3M: Number(json.data["Unemployment_Roll3M"]) || 0,
        optimismRoll6M: Number(json.data["Optimism_Roll6M"]) || 0,
        industrialProdChange6M:
          Number(json.data["IndustrialProd_Change6M"]) || 0,
        covidFlag: parseInt(json.data["COVID_Flag"], 10) || 0,
        optimismIndexNormalized:
          Number(json.data["Optimism_Index_Normalized"]) || 0,
        unemploymentRateNormalized:
          Number(json.data["unemployment_rate_Normalized"]) || 0,
        gdpGrowthRateNormalized:
          Number(json.data["GDP_Growth_Rate_Normalized"]) || 0,
      });
      setCurrentStep("Score");
    } else {
      setAlertMsg("Failed to fetch loan details");
      setShowAlert(true);
    }
  };

  return (
    <>
      {currentStep === "Loans" && (
        <div className="loan-underwrite">
          <div className="p-4">
            <Header token={token} setCompany={setCompany} />
            <Steps currentStep={"Loans"} />
            {tableData ? (
              <>
                <div className="d-flex gap-5 align-items-center justify-content-between">
                  <div className="toggle-page d-flex align-items-center gap-2">
                    <span>Score</span>
                    <label className="switch">
                      <input type="checkbox" defaultChecked={true} disabled />
                      <span className="slider"></span>
                    </label>
                    <span>Bypass</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Form.Label className="mb-0">Search:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Application Number"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          fetchData();
                        }
                      }}
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>

                <div className="datatable datatable-users list-table">
                  <MDBDataTable
                    striped
                    small
                    data={tableData}
                    paging={false}
                    searching={false}
                  />
                </div>
              </>
            ) : (
              <p>Loading loan data...</p>
            )}
          </div>
        </div>
      )}
      {currentStep === "Score" && (
        <div className="loan-underwrite">
          {isLoading && (
            <div id="loading">
              <img
                src={require("./../assets/images/ai.gif")}
                alt="Loading"
                width="100"
              />
            </div>
          )}
          <Header token={token} setCompany={setCompany} />
          <Container fluid className="container-wrapper">
            {showAlert && (
              <div className="alert-msg">
                <Container fluid>{alertMsg}</Container>
              </div>
            )}

            <Steps currentStep="Score" />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Application Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="applicationNumber"
                      value={inputs.applicationNumber || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Name of Business</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Office Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Loan Amount</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="loanAmount"
                      value={inputs.loanAmount || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Asset Type</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="city"
                      value={inputs.city || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <h5 className="mt-4 mb-3">Corp Details</h5>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Time in Business</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="timeInBusiness"
                      value={inputs.timeInBusiness || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Number of Employees</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="numberOfEmployees"
                      value={inputs.numberOfEmployees || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>High Credit</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="highCredit"
                      value={inputs.highCredit || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Paydex</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="paydex"
                      value={inputs.paydex || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Trade Lines</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="tradeLines"
                      value={inputs.tradeLines || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Suits/Liens/Judgements</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="suitsLiensJudgements"
                      value={inputs.suitsLiensJudgements || ""}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>History Clear</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="historyClearSwitch"
                      value={inputs.historyClearSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>UCC filings</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="uccFilingsSwitch"
                      value={inputs.uccFilingsSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>High Risk Industry</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="highRiskIndustrySwitch"
                      value={inputs.highRiskIndustrySwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Comparable Lease</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="comparableLeaseSwitch"
                      value={inputs.comparableLeaseSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Majority Equity Single Ownership</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="majorityEquitySingleOwnershipSwitch"
                      value={
                        inputs.majorityEquitySingleOwnershipSwitch || false
                      }
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Preferred Collateral</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="preferredCollateralSwitch"
                      value={inputs.preferredCollateralSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Soft Collateral</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="softCollateralSwitch"
                      value={inputs.softCollateralSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Intangibles</Form.Label>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Check
                        type="switch"
                        name="intangiblesSwitch"
                        value={inputs.intangiblesSwitch || false}
                        onChange={handleChange}
                        style={{ opacity: 1 }}
                      />
                      {inputs.intangiblesSwitch && (
                        <Form.Control
                          type="number"
                          min="0"
                          max="100"
                          placeholder="Enter here"
                          name="intangibles"
                          value={inputs.intangibles || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                          className="ms-2"
                        />
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Any Major Derog</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="anyMajorDerogSwitch"
                      value={inputs.anyMajorDerogSwitch || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                {/* <Col sm={12}>
                  <Form.Group className="mb-4 d-flex gap-2">
                    <Form.Check
                      type="checkbox"
                      name="vendorMustBeCleared"
                      value={inputs.venderMustBeCleared || false}
                      onChange={handleChange}
                      style={{ opacity: 1 }}
                    />
                    <Form.Label>Vendor must be cleared</Form.Label>
                  </Form.Group>
                </Col> */}
                {/* Show PG form if loanAmount > 100000 */}
                {Number(inputs.loanAmount) > 100000 && (
                  <>
                    <Col sm={12}>
                      <h5 className="mt-4 mb-3">
                        Personal Guarantor (PG) Details
                      </h5>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="mb-4">
                        <Form.Label>Time in Business</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter here"
                          name="pgTimeInBusiness"
                          value={inputs.pgTimeInBusiness || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="mb-4">
                        <Form.Label>FICO Score</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter here"
                          name="pgFicoScore"
                          value={inputs.pgFicoScore || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>

                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Paydex equal to or greater than 70 OR Multiple Lease
                          Repayments on PayNet
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="pgStrongPaymentHistorySwitch"
                          value={inputs.pgStrongPaymentHistorySwitch || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Non-Derogatory Navitas Payment History
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          2x Requested Amount in D&B, PayNet or any Loan (Except
                          Mortgage) on CBR
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Similar Amount in any Bureau (Except Mortgage)
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Copiers, Computers, Telecom Hardware, Medical,
                          Automotive or any Hard Asset
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                          style={{ opacity: 1 }}
                        />
                      </Form.Group>
                    </Col>
                    {/* Add more PG fields as needed */}
                  </>
                )}
                {/* {selectedType === "pg" && (
                  <>
                    
                  </>
                )} */}
              </Row>
              <Row className="flex justify-content-end">
                <Col sm="4" className="d-flex">
                  <Button
                    variant="transparent"
                    className="mt-4 mb-5 w-50"
                    type="submit"
                    onClick={() => setCurrentStep("Loans")}
                  >
                    Back
                  </Button>
                  <Button
                    variant="primary"
                    className="mt-4 mb-5 ms-3 w-50"
                    type="submit"
                    onClick={() => setCurrentStep("Rate")}
                  >
                    Score
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      )}
      {currentStep === "Rate" && (
        <div className="loan-underwrite">
          {isLoading && (
            <div id="loading">
              <img
                src={require("./../assets/images/ai.gif")}
                alt="Loading"
                width="100"
              />
            </div>
          )}
          <Header token={token} setCompany={setCompany} />
          <Container fluid className="container-wrapper">
            {showAlert && (
              <div className="alert-msg">
                <Container fluid>{alertMsg}</Container>
              </div>
            )}

            <Steps currentStep="Rate" />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Application Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="applicationNumber"
                      value={inputs.applicationNumber || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Name of Business</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Office Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Loan Amount</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="loanAmount"
                      value={inputs.loanAmount || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Asset Type</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="nameOfBusiness"
                      value={inputs.nameOfBusiness || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="city"
                      value={inputs.city || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <h5 className="mt-4 mb-3">Corp Details</h5>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Time in Business</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="timeInBusiness"
                      value={inputs.timeInBusiness || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Number of Employees</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="numberOfEmployees"
                      value={inputs.numberOfEmployees || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>High Credit</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="highCredit"
                      value={inputs.highCredit || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Paydex</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="paydex"
                      value={inputs.paydex || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Trade Lines</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="tradeLines"
                      value={inputs.tradeLines || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Suits/Liens/Judgements</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter here"
                      name="suitsLiensJudgements"
                      value={inputs.suitsLiensJudgements || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>History Clear</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="historyClearSwitch"
                      value={inputs.historyClearSwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>UCC filings</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="uccFilingsSwitch"
                      value={inputs.uccFilingsSwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>High Risk Industry</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="highRiskIndustrySwitch"
                      value={inputs.highRiskIndustrySwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Comparable Lease</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="comparableLeaseSwitch"
                      value={inputs.comparableLeaseSwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Majority Equity Single Ownership</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="majorityEquitySingleOwnershipSwitch"
                      value={
                        inputs.majorityEquitySingleOwnershipSwitch || false
                      }
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Preferred Collateral</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="preferredCollateralSwitch"
                      value={inputs.preferredCollateralSwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Soft Collateral</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="softCollateralSwitch"
                      value={inputs.softCollateralSwitch || false}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Intangibles</Form.Label>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Check
                        type="switch"
                        name="intangiblesSwitch"
                        value={inputs.intangiblesSwitch || false}
                        onChange={handleChange}
                      />
                      {inputs.intangiblesSwitch && (
                        <Form.Control
                          type="number"
                          min="0"
                          max="100"
                          placeholder="Enter here"
                          name="intangibles"
                          value={inputs.intangibles || ""}
                          onChange={handleChange}
                          className="ms-2"
                        />
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col sm={4}>
                  <Form.Group className="mb-4">
                    <Form.Label>Any Major Derog</Form.Label>
                    <Form.Check
                      type="switch"
                      placeholder="Enter here"
                      name="anyMajorDerogSwitch"
                      value={inputs.anyMajorDerogSwitch || false}
                      onChange={handleChange}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                {/* <Col sm={12}>
                  <Form.Group className="mb-4 d-flex gap-2">
                    <Form.Check
                      type="checkbox"
                      name="vendorMustBeCleared"
                      value={inputs.venderMustBeCleared || false}
                      onChange={handleChange}
                    />
                    <Form.Label>Vendor must be cleared</Form.Label>
                  </Form.Group>
                </Col> */}
                {/* Show PG form if loanAmount > 100000 */}
                {Number(inputs.loanAmount) > 100000 && (
                  <>
                    <Col sm={12}>
                      <h5 className="mt-4 mb-3">
                        Personal Guarantor (PG) Details
                      </h5>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="mb-4">
                        <Form.Label>Time in Business</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter here"
                          name="pgTimeInBusiness"
                          value={inputs.pgTimeInBusiness || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="mb-4">
                        <Form.Label>FICO Score</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter here"
                          name="pgFicoScore"
                          value={inputs.pgFicoScore || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Paydex equal to or greater than 70 OR Multiple Lease
                          Repayments on PayNet
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="pgStrongPaymentHistorySwitch"
                          value={inputs.pgStrongPaymentHistorySwitch || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Non-Derogatory Navitas Payment History
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          2x Requested Amount in D&B, PayNet or any Loan (Except
                          Mortgage) on CBR
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Similar Amount in any Bureau (Except Mortgage)
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Copiers, Computers, Telecom Hardware, Medical,
                          Automotive or any Hard Asset
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          placeholder="Enter here"
                          name="suitsLiensJudgements"
                          value={inputs.suitsLiensJudgements || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    {/* Add more PG fields as needed */}
                  </>
                )}
                {/* {selectedType === "pg" && (
                  <>
                    
                  </>
                )} */}
              </Row>
              <Row className="flex justify-content-end">
                <Col sm="4" className="d-flex">
                  <Button
                    variant="transparent"
                    className="mt-4 mb-5 w-50"
                    type="submit"
                    onClick={() => setCurrentStep("Score")}
                  >
                    Back
                  </Button>
                  <Button
                    variant="primary"
                    className="mt-4 mb-5 ms-3 w-50"
                    type="submit"
                    onClick={() => setCurrentStep("Underwrite Application")}
                  >
                    Rate
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      )}
      {currentStep === "Underwrite Application" && (
        <UnderwriteLoan
          applicationInputs={inputs}
          setCurrentStep={setCurrentStep}
        />
      )}
    </>
  );
};

export default LoanUnderwriteLanding;
